module.exports = __webpack_public_path__ + "img/etapa5.d20d8fe6.png";